import Http from '../http'

export const index = (page, name) => Http.get(`/materials?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/materials', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/materials/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/materials/${id}`, { headers: { Authorization: localStorage.token } })
